<template>
  <div class="container">
    <h1 class="container-title">{{ adminText('organizationAll.list_of_members_cd033900', 'List of Members') }}</h1>
    <text-field
      v-model="searchTerm"
      append-icon="search"
      style="width: 65%"
      :label="adminText('organizationAll.search_members_by_name_or_member_id_number_d635040d', 'Search Members by Name or Member ID number')"
    />
    <div v-if="!$apollo.loading" class="attendee_table">
      <div
        v-if="members.length === 0"
        class="no-attendees-message-container border__left border__right"
      >
        <span class="no-attendees-message">{{ adminText('organizationAll.no_matching_records_found_0c7f0a64', 'No matching records found.') }}</span>
      </div>
      <table-list
        :hide-checkbox="true"
        :selected.sync="selected"
        :organization-slug="organizationSlug"
        :attendees="members"
        body-style="grid-auto-columns: 50px minmax(150px, 250px) !important;"
        :visible-fields="visibleFields"
        :attendee-fields="attendeeFields"
        :pagination="pagination"
        @click="$emit('editPlan', $event)"
        @sort="handleSort($event)"
      />
      <table-pagination
        :pagination="pagination"
        :total-attendees="totalMembersCount"
        @change="handlePagination($event)"
        @changePerPage="handlePagination($event)"
      />
    </div>
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import tableList from '../../accreditations/attendee-table/list.vue'
import tablePagination from '../../accreditations/attendee-table/pagination.vue'
import { GET_ALL_MEMBERSHIP_USERS_WITH_PAGINATION } from '@/graphql/membershipUser.graphql'
import moment from 'moment'

export default {
  mixins: [OrganizationLocalization],
  name: 'subscription-plan-list',
  components: {
    tableList,
    tablePagination,
  },
  props: {
    organizationSlug: {
      type: String,
    },
  },
  data() {
    const { pagination } = this.getInitialFromQueryParams()

    return {
      members: [],
      pagination,
      showDeleteDialog: false,
      openCreateModal: false,
      openUpdateModal: false,
      selected: [],
      attendeeFields: {},
      visibleFields: ['Name', 'Member ID No.', 'Membership', 'Created', 'Expires'],
      totalMembersCount: 0,
      searchTerm: null,
    }
  },
  methods: {
    async handlePagination({ page, per_page }) {
      const { page: currentPage, per_page: currentPerPage } = this.pagination
      if (currentPage > page && currentPage === 1) return
      if (page > currentPage && !(this.totalMembersCount - currentPerPage * currentPage > 0)) return

      this.pagination = {
        ...this.pagination,
        per_page: per_page === 'All' ? -1 : per_page,
        page: page,
      }

      await this.addPaginationToRoute(this.pagination)
    },
    async handleSort(sortBy) {
      const { per_page, page, sortBy: thisSortBy, descending } = this.pagination
      const pagination = {
        page,
        per_page,
        sortBy,
        descending: sortBy === thisSortBy ? !descending : false,
      }
      await this.addPaginationToRoute(pagination)
      this.pagination = pagination
    },
    getInitialFromQueryParams() {
      const { per_page, page, sortBy, descending } = this.$route.query

      return {
        pagination: {
          page: parseInt(page, 10) || 1,
          per_page: parseInt(per_page, 10) || 10,
          sortBy: sortBy,
          descending: descending ? !!descending : false,
        },
      }
    },
    async addPaginationToRoute({ page, per_page, sortBy, descending }) {
      await this.$router.replace({
        query: {
          ...this.$route.query,
          per_page,
          page,
          sortBy,
          descending: descending ? 1 : 0,
        },
      })
    },
  },
  apollo: {
    getAllMembershipUsers: {
      query: GET_ALL_MEMBERSHIP_USERS_WITH_PAGINATION,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
          pagination: this.pagination,
          searchTerm: this.searchTerm,
        }
      },
      manual: true,
      async result({ loading, data }) {
        if (!loading && data) {
          const { getAllMembershipUsersWithPagination } = data
          this.members = getAllMembershipUsersWithPagination.items.map(member => {
            return {
              id: member.id,
              name: member.name,
              code: member.code,
              membership: member.membershipPlan.name,
              created: moment(member.createdAt).format('DD.MM.YYYY HH:mm'),
              expires: moment(member.validUntil).format('DD.MM.YYYY HH:mm'),
            }
          })
          this.totalMembersCount = getAllMembershipUsersWithPagination.totalCount
        }
      },
    },
  },
}
</script>

<style scoped>
.container {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  max-width: 64.875rem;
}
.container-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
</style>
